// Dependencias generales
import { useEffect, useState } from 'react';
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';
import InitialConfigHeader from '../../../components/InitialConfig/UserInitialConfigHeader';
import ReactGA from "react-ga4";
import BillingPlans from "../BillingPlans.js"

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js");
var generalCommonJS = require("../../../js/generalCommon.js")
var stripeCommonJS = require("../../../js/stripeCommon.js")

// Initial config - Welcome
const Welcome = () => {
  
  const [updateBillingPlans, setUpdateBillingPlans] = useState(0)

  useEffect(() => {    

    if(initialConfigCommonJS.antiBackOnboarding() === false){
      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("WELCOME_USER",setUpdateBillingPlans)
      cargarConfiguracionActualPaso()      
      stripeCommonJS.cargarPlanesStripe()
    
      document.title = "HELIAS - Bienvenid@"

      generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - WELCOME', "", "")      

    }

  }, []);

  function cargarConfiguracionActualPaso(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "GeneralInfo": "",      
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{         

            //Si no hay datos configurados entonces no hago nada
  
            console.log("Información cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {  
          initialConfigCommonJS.mostrarMensajeInformativo('Se produjo un error al cargar la configuracion.',"negative")
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
  }

  return (      
    <main>

      <InitialConfigHeader step={"WELCOME"}/>

      <section id="welcome-01" className="step wrapper">
           
        <div>
          <div className="content-wrapper wrapper">            
            <BillingPlans updateBillingPlans={updateBillingPlans}/>
          </div>
        </div>

      </section>

    </main>
  )
}

export default Welcome